<app-navbar></app-navbar>

<div
  class="container card"
  style="
    padding: 20px; //background-image: url('assets/img/school/bg.png');
    background-color: #005a63;
    background-size: 100px;
    background-attachment: fixed;
  "
>
  <div class="row justify-content-center">
    <div
      align="left"
      class="text-justify"
      style="line-height: 25px; font-size: 16px"
    >
      <div class="row">
        <div class="col-lg-4 col-md-6 col-sm-12"></div>
        <div class="col-lg-4 col-md-6 col-sm-12">
          <div class="single-team-box" >
            <div class="image" >
              <img
                src="assets/img/school/admin/1.jpeg"
                alt="team"
                style="width: 100%; height: auto"
              />
            </div>
            <div class="content" >
              <h3>
                General S M Shafiuddin Ahmed, SBP (BAR), OSP, ndu, psc, PhD
              </h3>
              <span style="color: white;">Area Chief Patron, Proyash-Chattogram</span>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12"></div>
        <div class="col-lg-4 col-md-6 col-sm-12">
          <div class="single-team-box">
            <div class="image">
              <img
                src="assets/img/school/admin/2.jpeg"
                alt="team"
                style="width: 100%; height: auto"
              />
            </div>
            <div class="content">
              <h3>Noorjahan Ahmed</h3>
              <span style="color: white;">Patron, Proyash-Chattogram</span>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12">
          <div class="single-team-box">
            <div class="image">
              <img
                src="assets/img/school/admin/3.jpg"
                alt="team"
                style="width: 100%; height: auto"
              />
            </div>
            <div class="content">
              <h3>
                Maj Gen Md Mainur Rahman
                SUP, awc, psc 
              </h3>
              <span style="color: white;">Area Chief Patron, Proyash-Chattogram</span>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12">
          <div class="single-team-box">
            <div class="image">
              <img
                src="assets/img/school/admin/4.jpg"
                alt="team"
                style="width: 100%; height: auto"
              />
            </div>
            <div class="content">
              <h3>Shirin Sultana</h3>
              <span style="color: white;">Assistant Patron, Proyash-Chattogram</span>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12">
          <div class="single-team-box">
            <div class="image">
              <img
                src="assets/img/school/admin/5.jpeg"
                alt="team"
                style="width: 100%; height: auto"
              />
            </div>
            <div class="content">
              <h3>Col Md Enamul Islam, psc, PhD</h3>
              <span style="color: white;">Col Admin and Chairman, Proyash-Chattogram</span>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12">
          <div class="single-team-box">
            <div class="image">
              <img
                src="assets/img/school/admin/6.jpeg"
                alt="team"
                style="width: 100%; height: auto"
              />
            </div>
            <div class="content">
              <h3>Lieutenant Colonel Mohammad Mahbub Morshed, psc</h3>
              <span style="color: white;">Principal, Proyash-Chattogram</span>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12">
          <div class="single-team-box">
            <div class="image">
              <img
                src="assets/img/school/admin/7.jpeg"
                alt="team"
                style="width: 100%; height: auto"
              />
            </div>
            <div class="content">
              <h3>Mashim Ara Begum</h3>
              <span style="color: white;">Vice Principal, Proyash-Chattogram</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
